import { UseRecordsOptions } from "../../api/useRecords";

export const createRoutedCustomFilters = (options: UseRecordsOptions | undefined) => {
  if (!options) return [];
  const designedCustomFields = options.fieldsToAddFilter
    ? options.fieldsToAddFilter.map((item) => ({ field: item.field, isCustomRoute: !!item?.isCustomRoute }))
    : [];

  if (!options.groupsOptions?.fieldsWithExtraOptions) return designedCustomFields;
  const isApiCustomFields = options.groupsOptions.fieldsWithExtraOptions?.filter(
    (item) => item.field && typeof item.field === "string" && !!item.isCustomRoute
  );
  const apiCustomFields = isApiCustomFields
    ? isApiCustomFields.map((item) => ({ field: item.field as string, isCustomRoute: item.isCustomRoute }))
    : [];

  return [...designedCustomFields, ...apiCustomFields];
};

export const makeSelectionField = (fieldName: string, choices: Array<{ text: string; value: string | number }>) => {
  const selectDropdown = {
    field: fieldName,
    name: fieldName,
    interface: "list",
    type: "string",
    meta: {
      field: fieldName,
      type: "string",
      interface: "select-dropdown",
      options: {
        choices: choices,
      },
    },
  };
  return selectDropdown;
};

const dateField = { field: "date", settings: { interface: "date", type: "date" } };

const treatmentSelectionField = {
  fieldName: "treatment",
  choices: [
    { text: "Neurofeedback", value: "neuroFeedback" },
    { text: "Psicologia", value: "psychology" },
  ],
};

const appointmentFulfillmentSelectionField = {
  fieldName: "provided_services_fulfillment",
  choices: [
    { text: "Cumprido", value: "fulfilled" },
    { text: "Não cumprido", value: "notFulfilled" },
  ],
};

const servicesProvidedSelectionField = {
  fieldName: "provided_services_state",
  choices: [
    { text: "A decorrer", value: "onGoing" },
    { text: "Não existe", value: "notApplicable" },
  ],
};

const allServicesProvidedSelectionField = {
  fieldName: "provided_services_state",
  choices: [
    { text: "Existe", value: "exist" },
    { text: "Não existe", value: "notExist" },
  ],
};

export const customizedTreatmentProvidedAppointmentFields = [
  {
    field: "last_session",
    headerName: "Tratamento Ativo - Última sessão realizada",
    isCustomRoute: true,
    settings: {
      type: "provided_appointments_last_and_next_session",
      options: {
        fields: [makeSelectionField(treatmentSelectionField.fieldName, treatmentSelectionField.choices), dateField],
      },
    },
  },
  {
    field: "next_session",
    headerName: "Tratamento Ativo - Próxima sessão agendada",
    isCustomRoute: true,
    settings: {
      type: "provided_appointments_last_and_next_session",
      options: {
        fields: [makeSelectionField(treatmentSelectionField.fieldName, treatmentSelectionField.choices), dateField],
      },
    },
  },
  {
    field: "appointment_fulfillment",
    headerName: "Tratamento Ativo - Agendamento cumprido",
    isCustomRoute: true,
    settings: {
      type: "services_provided",
      options: {
        fields: [
          makeSelectionField(treatmentSelectionField.fieldName, treatmentSelectionField.choices),
          makeSelectionField(
            appointmentFulfillmentSelectionField.fieldName,
            appointmentFulfillmentSelectionField.choices
          ),
        ],
      },
    },
  },
  {
    field: "services_provided",
    headerName: "Tratamento Ativo - A decorrer",
    isCustomRoute: true,
    settings: {
      type: "services_provided",
      options: {
        fields: [
          makeSelectionField(treatmentSelectionField.fieldName, treatmentSelectionField.choices),
          makeSelectionField(servicesProvidedSelectionField.fieldName, servicesProvidedSelectionField.choices),
        ],
      },
    },
  },
  {
    field: "services_provided_all",
    headerName: "Tratamento Ativo - Geral",
    isCustomRoute: true,
    settings: {
      type: "services_provided",
      options: {
        fields: [
          makeSelectionField(treatmentSelectionField.fieldName, treatmentSelectionField.choices),
          makeSelectionField(allServicesProvidedSelectionField.fieldName, allServicesProvidedSelectionField.choices),
        ],
      },
    },
  },
];
